/* global MEDIA_FETCH_COUNT: true */

import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { graphql } from 'react-relay';

import EventGpsSearchPage from './EventGpsSearchPage';
import QueryHandler from '../components/misc/QueryHandler';

import { getCustomerKey } from '../utils/browser-storage';

////////////////////////////////////////////
// TODO MISSING TESTS
////////////////////////////////////////////

const EventGpsSearchPageQueryRenderer = (props) => {
  const { language, id, fileId, stravaActivityId, startnumber, stravaActivityStartDate } =
    useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const code2FA = queryParams.get('code2fa');
  const stravaToken = queryParams.get('codeStrava');
  const formattedStravaActivityId = parseInt(stravaActivityId)
  const decodedStravaActivityStartDate = stravaActivityStartDate && new Date(window.atob(stravaActivityStartDate))

  const isStravaSearch = location.pathname.includes('/strava/');
  const customerKey = getCustomerKey(id, startnumber);

  return (
    <QueryHandler
      query={graphql`
        query EventGpsSearchPageQueryRendererQuery(
          $eventId: ID!
          $language: String
          $startnumber: ID
          $gpxFileId: ID
          $count: Int!
          $cursor: String
          $secondFactor: String
          $individualPart: String
          $noStartnumber: Boolean
          $isRecheckPage: Boolean!
          $stravaToken: String
          $stravaActivityId: Int
          $stravaActivityStartDate: NaiveDatetime
          $hasStravaToken: Boolean
        ) {
          viewer {
            ...EventGpsSearchPage_viewer
          }
        }
      `}
      variables={{
        eventId: id,
        language: language,
        startnumber: startnumber != undefined ? startnumber : '',
        gpxFileId: fileId || null,
        count: MEDIA_FETCH_COUNT,
        secondFactor: code2FA || customerKey,
        individualPart: '',
        noStartnumber: startnumber === undefined,
        isRecheckPage: false,
        stravaToken: stravaToken || null,
        stravaActivityId: formattedStravaActivityId || null,
        hasStravaToken: !!isStravaSearch,
        stravaActivityStartDate: decodedStravaActivityStartDate || null,
      }}
      redirectTo={`/event/${id}`}
      render={(props) => {
        return (
          <EventGpsSearchPage
            viewer={props.viewer}
            snFromUrl={startnumber != undefined ? startnumber : ''}
            gpxFileIdFromUrl={fileId || null}
            customerKey={code2FA || customerKey}
            stravaActivityId={formattedStravaActivityId || null}
            stravaActivityStartDate={decodedStravaActivityStartDate || null}
            stravaToken={stravaToken || null}
          />
        );
      }}
    />
  );
};

EventGpsSearchPageQueryRenderer.propTypes = {
  viewer: PropTypes.object,
};

export default EventGpsSearchPageQueryRenderer;